/* CIPRIO premium interaction layer */
(() => {
  document.documentElement.classList.add('ciprio-premium-active');
  const onScroll = () => document.documentElement.classList.toggle('ciprio-scrolled', window.scrollY > 24);
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});
})();
